define('app/routers/router',['app/routers/global_router','app/routers/location_page_router',
        'app/routers/travel_search_router'], function() {});

